module.exports = __webpack_public_path__ + "img/fyt_p5.6f8f60e8.png";